import React from 'react'
import { Upload, message } from 'antd'
import classnames from 'classnames'
import request from 'meinian-package/src/utils/request'

const { Dragger } = Upload
const CDN_HOST = 'https://zhiyi-image.oss-cn-hangzhou.aliyuncs.com/'
const CDN_DIR = 'ins-selected/'
const GET_TOKEN_API = '/upload/get-oss-upload-token'
const MAX_SIZE = 10

function unionid({ mime, customDir }) {
  return `${customDir || CDN_DIR + new Date().getTime()}_${Math.random().toString(32).substr(2, 10)}${mime || '.png'}`
}

const UploadImg = ({
  className,
  style,
  children,
  multiple = false,
  maxFileSize,
  beforeUpload,
  onStart,
  onSuccess,
  onUploadProgress,
  onError,
  customDir,
  prevent,
  draggable,
  onDrop,
  supportPaste = true,
}) => {
  const maxSize = maxFileSize || MAX_SIZE

  const customRequest = async ({ file }) => {
    if (prevent) return
    if (file.size / 1024 / 1024 > maxSize) {
      if (onError) {
        onError?.(`文件大小不能超过${maxSize}M`)
      } else {
        message.error(`文件大小不能超过${maxSize}M`)
      }
      return
    }
    onStart?.()
    const result = await request.get(GET_TOKEN_API, { params: { dir: customDir || CDN_DIR } })
    const res = result.sign
    const key = unionid({ customDir })
    try {
      await request.formdata(
        res.host,
        {
          OSSAccessKeyId: res.accessid,
          signature: res.signature,
          policy: res.policy,
          success_action_status: 200,
          key,
          file,
        },
        e => onUploadProgress?.(e, key, file)
      )
      onSuccess?.(`${CDN_HOST + key}`, file.name)
    } catch (error) {
      onError?.('上传失败')
    }
  }

  const uploadHandle = {
    name: 'file',
    accept: '.png,.jpeg,.jpg',
    multiple,
    showUploadList: false,
    onDrop,
    customRequest,
  }

  const onPaste = event => {
    if (!supportPaste) return
    const { items } = event.clipboardData || event.originalEvent.clipboardData
    for (let i = 0; i < items.length; i++) {
      if (items[i].type.indexOf('image') !== -1) {
        customRequest({ file: items[i].getAsFile() })
        break
      }
    }
  }

  return (
    <div className={classnames('upload-img', className)} style={style} onPaste={onPaste}>
      {draggable ? (
        <Dragger beforeUpload={beforeUpload} {...uploadHandle}>
          {children}
        </Dragger>
      ) : (
        <Upload beforeUpload={beforeUpload} {...uploadHandle}>
          {children}
        </Upload>
      )}
    </div>
  )
}

export default UploadImg
